export const getCargoPortKey = (
	portId: number,
	index: number,
	action: 'loading' | 'discharging',
) => `${portId}_${index}_${action}`;
